import { AppointmentRequestStatus } from 'apps/wrapper/src/services/appointment/types/appointment-request-status';
import { AppointmentRequestSummary } from 'apps/wrapper/src/services/appointment/types/appointment-request-summary';
import { PmsWritebackStatus } from 'apps/wrapper/src/services/appointment/types/pms-writeback-status';
import { FC } from 'react';
import {
  ApprovedStatusMessage,
  DirectBookingSuccessStatusMessage,
  DismissedStatusMessage,
  PendingReviewStatusMessage,
  WritebackFailedStatusMessage,
  WritebackProcessingStatusMessage
} from '../appt-request-list-item.styles';

export interface StatusMessageFactoryProps {
  appointmentRequest: AppointmentRequestSummary;
}

export const StatusMessageFactory: FC<StatusMessageFactoryProps> = (props) => {
  const { appointmentRequest } = props;

  if (
    appointmentRequest.status == AppointmentRequestStatus.Cancelled ||
    appointmentRequest.status == AppointmentRequestStatus.Deleted
  ) {
    return <DismissedStatusMessage date={new Date(appointmentRequest.updatedDate!)} />;
  }

  if (
    appointmentRequest.pmsWritebackStatus !== undefined &&
    !appointmentRequest.isCancelRequest &&
    !appointmentRequest.isRescheduleRequest
  ) {
    if (appointmentRequest.pmsWritebackStatus === PmsWritebackStatus.Pending)
      return <WritebackProcessingStatusMessage />;
    else if (appointmentRequest.pmsWritebackStatus === PmsWritebackStatus.Error)
      return <WritebackFailedStatusMessage />;
    else if (appointmentRequest.pmsWritebackStatus === PmsWritebackStatus.Synced)
      return appointmentRequest.isDirectlyBooked ? (
        <DirectBookingSuccessStatusMessage date={new Date(appointmentRequest.pmsSyncDate!)} />
      ) : (
        <ApprovedStatusMessage date={new Date(appointmentRequest.pmsSyncDate!)} />
      );
  }

  if (
    appointmentRequest.status == AppointmentRequestStatus.New ||
    appointmentRequest.status == AppointmentRequestStatus.Pending
  ) {
    return <PendingReviewStatusMessage />;
  }

  if (
    appointmentRequest.status == AppointmentRequestStatus.Confirmed ||
    appointmentRequest.status == AppointmentRequestStatus.Unconfirmed
  ) {
    return <ApprovedStatusMessage date={new Date(appointmentRequest.updatedDate!)} />;
  }

  return null;
};
